<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <div class="p-3">
            <img src="@/assets/grid/kaffee.webp"
                class="w-full aspect-video max-h-[500px] object-bottom object-cover rounded-md shadow-md">
        </div>
        <div class="flex flex-col md:flex-row pt-12 md:pt-24 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Gemeindenachmittag</h1>
                    <p class="text-lg text-gray-500 mt-3">Lasst uns zusammenkommen!</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Regelmäßig treffen sich die Mitglieder der Rastenberger Gemeinde, um bei gemütlichem
                        Kaffeetrinken miteinander über verschiedene Impulse ins Gespräch zu kommen und miteinander zu
                        singen.
                        <br>
                        <br>
                        <p><span class="font-bold">Wo?</span><br>Gemeinderaum Rastenberg</p>
                        <br>
                        <p><span class="font-bold">Wann?</span><br>Letzter Mittwoch im Monat ab 14.00 Uhr</p>
                    </p>
                </div>
            </div>
            <GridNav />
        </div>
    </div>
</template>

<script>
import GridNav from '@/components/gridNav.vue'

export default {
    name: 'Gemeindenachmittag',
    data() {
        return {
        }
    },
    components: {
        GridNav
    }
}
</script>